var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardReportsInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.16699,
    y: 0.700195,
    width: 31,
    height: 31,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.16699,
    y: 0.700195,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "#E4E4E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1321 24.8595C23.6128 24.8595 24.8177 23.6546 24.8177 22.1732V9.0835C24.8177 7.60288 23.6128 6.39795 22.1321 6.39795H11.4365C9.9559 6.39795 8.75098 7.60288 8.75098 9.0835V22.1732C8.75098 23.6546 9.9559 24.8595 11.4365 24.8595H22.1321ZM10.2894 22.1732V9.0835C10.2894 8.45098 10.804 7.93641 11.4365 7.93641H22.1321C22.7646 7.93641 23.2792 8.45098 23.2792 9.0835V22.1732C23.2792 22.8065 22.7646 23.321 22.1321 23.321H11.4365C10.804 23.321 10.2894 22.8065 10.2894 22.1732Z",
    fill: "#7F7F7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7472 20.0322H13.3503C12.9251 20.0322 12.5811 20.3763 12.5811 20.8015C12.5811 21.2266 12.9251 21.5707 13.3503 21.5707H16.7472C17.1724 21.5707 17.5165 21.2266 17.5165 20.8015C17.5165 20.3763 17.1724 20.0322 16.7472 20.0322Z",
    fill: "#7F7F7F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2193 16.3574H13.3503C12.9251 16.3574 12.5811 16.7015 12.5811 17.1267C12.5811 17.5518 12.9251 17.8959 13.3503 17.8959H20.2193C20.6445 17.8959 20.9885 17.5518 20.9885 17.1267C20.9885 16.7015 20.6445 16.3574 20.2193 16.3574Z",
    fill: "#7F7F7F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4564 14.3471L15.3915 12.3278L17.7863 13.8543C18.1011 14.0556 18.5202 13.9993 18.7719 13.7191L21.2396 10.9689C21.5235 10.6527 21.4972 10.1666 21.181 9.88268C20.8655 9.59873 20.3795 9.62577 20.0947 9.94128L18.0627 12.2061L15.6859 10.691C15.3779 10.4964 14.9723 10.543 14.7176 10.8074L12.3461 13.2819C12.0516 13.5891 12.0621 14.0759 12.3686 14.3696C12.6743 14.663 13.161 14.6542 13.4564 14.3471Z",
    fill: "#7F7F7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardReportsInsights);
export default __webpack_public_path__ + "static/media/dashboardReportsInsights.368d55d943c6eb97168a88fdba963403.svg";
export { ForwardRef as ReactComponent };